import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/shared/styles/index.css';
import App from './App.tsx';

const container = document.getElementById('root')!;
createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>
);

if (import.meta.env.PROD) {
  const loadSentry = () => void import('./sentry.ts');

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(loadSentry);
  } else {
    setTimeout(loadSentry, 0);
  }
}
